export default "__VITE_ASSET__57699ae1__"